export const ANNOTATION_ICON_SIZE = 40;
export const ANNOTATION_DEFAULT_SCALE = ANNOTATION_ICON_SIZE / 20;
export const DEFAULT_ANNOTATION_WIDTH = 100;
export const DEFAULT_ANNOTATION_HEIGHT = 100;
export const DIFFERENT_CRITERION_OPACITY = 0.3;
export const ANNOTATION_OBJECT_NAME = 'A';
export const MINIMUM_ANNOTATION_SIZE = 10;

export const ANNOTATION_STEP = 10;
export const SCROLL_HORIZONTAL_STEP = 10;
export const SCROLL_VERTICAL_STEP = 10;
export const EDGE_PADDING = 30;
